import './App.css';
import React from 'react';
import { ethers, providers } from "ethers";
import { HexColorPicker, HexColorInput } from "react-colorful";
import Web3Modal from "web3modal";
import WalletConnectProvider from '@walletconnect/web3-provider'

const INFURA_ID = '6a78d5605a354e9f98cd1b060412f42a'

class App extends React.Component {
  constructor(props) {
    super(props);
    var color = new URLSearchParams(window.location.search).get('color') || Math.floor(Math.random()*16777215).toString(16).toUpperCase();

    if (props && props.match && props.match.params && props.match.params.color) {
      color = props.match.params.color;
    }
    this.state = {
      daiContract: null,
      provider: null,
      color: "#" + color,
      showColorPicker: true,
      web3Modal: new Web3Modal({
        network: "mainnet",
        cacheProvider: true,
        providerOptions: {
          walletconnect: {
            package: WalletConnectProvider, // required
            options: {
              infuraId: INFURA_ID, // required
            },
          },
          metamask: {
            id: "injected",
            name: "MetaMask",
            type: "injected",
            check: "isMetaMask"
          },
        }
      }),

    };
    
    this.updateContractAndProvider = this.updateContractAndProvider.bind(this);
    this.connectToWallet = this.connectToWallet.bind(this);
    this.render = this.render.bind(this);
    this.setColor = this.setColor.bind(this);
    this.style = {
      "backgroundColor" : this.state.color
    }
  }
  
  async connectToWallet() {
    // await window.ethereum.enable();
    const provider = await this.state.web3Modal.connect();
    
    // Subscribe to accounts change
    provider.on("accountsChanged", (accounts) => {
      console.log(accounts);
    });

    // Subscribe to chainId change
    provider.on("chainChanged", (chainId) => {
      console.log(chainId);
    });

    // Subscribe to provider connection
    provider.on("connect", (info) => {
      console.log(info);
    });

    // Subscribe to provider disconnection
    provider.on("disconnect", (error) => {
      console.log(error);
    });
    
    // await window.ethereum.send('eth_requestAccounts');
    const web3Provider = new providers.Web3Provider(provider)
    this.setState({provider : web3Provider});

    await this.updateContractAndProvider();
  }
  
  async updateContractAndProvider() {
    var newDaiContract = this.fetchContract(this.state.provider);
    this.setState({daiContract: newDaiContract});
  }
  
  fetchContract(provider) {
    const daiAddress = "0x35a4d49ec614a96a573afbe0a4b74ea472ac25d1";
    let colorFile = require("./Color.json");
    var daiAbi = colorFile.abi;
    
    // The Contract object
    return new ethers.Contract(daiAddress, daiAbi, provider);
  }
  
  setColor(c) {
    this.setState({ color: c });
  }
  
  async getContractWithSigner() {
    const signer = this.state.provider.getSigner()
    const daiWithSigner = this.state.daiContract.connect(signer);
    return daiWithSigner
  }
  
  async mint() {
    this.updateContractAndProvider();
    const daiWithSigner = await this.getContractWithSigner(this.state.daiContract, this.state.provider);
    
    await daiWithSigner.mint();
  }
  
  async mintHex(hexStr) {
    this.updateContractAndProvider();
    const daiWithSigner = await this.getContractWithSigner(this.state.daiContract, this.state.provider);
    const publicPrice = ethers.utils.formatEther(await daiWithSigner.publicPrice());
    
    let overrides = {
      value: ethers.utils.parseEther(publicPrice)
    };
    try {
      var sanitizedHex = hexStr.toUpperCase().replace('#', '');
      await daiWithSigner.mintHex(sanitizedHex, overrides);
    } catch(error) {
      var errorMsg = error.message;
      console.log(errorMsg);
    }    
  }
  
  render() {
    return (
      <div className="App" style={{"backgroundColor": this.state.color }}>
      <header className="App-header">
        <div id="connectedApp">
        <div id="segmentedControl">
        <button className="segmentedButton" style={{"backgroundColor": this.state.showColorPicker ? "white" : this.state.color, "color": this.state.showColorPicker ? this.state.color : "white" }} onClick={() => this.setState( { showColorPicker : true } )}>Choose</button>
        <button className="segmentedButton" style={{"backgroundColor": this.state.showColorPicker ? this.state.color : "white", "color": this.state.showColorPicker ? "white" : this.state.color }} onClick={() => this.setState( { showColorPicker : false } )}>Random</button>
        </div>
          { this.state.showColorPicker == true ? (
            <div>
              <HexColorPicker id="hexColorPicker" color={this.state.color} onChange={this.setColor} />
              <HexColorInput  style={{"color":"white", "backgroundColor": this.state.color }} id="hexColorInput" color={this.state.color.toUpperCase()} onChange={this.setColor} />
              <br />
              { this.state.provider != null && this.state.daiContract != null ? (
                <button className="mintButton" style={{"backgroundColor":"white", "color": this.state.color }} onClick={() => this.mintHex(this.state.color)} disabled={this.state.color.length == 6 }  >Mint →</button>
              ) : (
                <button className="mintButton" onClick={this.connectToWallet}>Connect Wallet</button>
              ) }
              <p className="price">0.01Ξ + ⛽️</p>
            </div>
          ) : (
            <div>
              <div id="mysteryBlockInner"><br /><br />Only Minting Will Reveal Your Ordained Color</div>
              <br />
              { this.state.provider != null && this.state.daiContract != null ? (
                <button className="mintButton" style={{"backgroundColor":"white", "color": this.state.color }} onClick={() => this.mint() }>Mint →</button>
              ) : (
                <button className="mintButton" onClick={this.connectToWallet}>Connect Wallet</button>
              ) }
              <p className="price">Free + ⛽️</p>
            </div>
          ) }
          <a class="externalLink" href="https://discord.gg/mqD9nX5Rcg">Discord</a>
          <a class="externalLink" href="https://etherscan.io/address/0x35a4d49EC614a96a573aFBe0A4b74EA472aC25d1#writeContract">Etherscan</a>
          <a class="externalLink" href="https://opensea.io/collection/colors-for-everyone">OpenSea</a>
          </div>
        </header>
        </div>
        );
      }
    }
          
          export default App;
          